.card {
    max-width: 100%;
    overflow: hidden;
}

.header {
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-lg);
    background-color: color-mix(
        in srgb,
        var(--mantine-color-dibblue-0) 40%,
        transparent
    );
    border-bottom: 1px solid var(--mantine-color-default-border);
}

.headerIcon {
    color: var(--mantine-color-dibblue-9);
    flex-shrink: 0;
}

.headerTitleGroup {
    flex: 1;
    min-width: 0;
    cursor: pointer;
}

.headerTitle {
    min-width: 0;
    overflow-wrap: anywhere;
}

.body {
    padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);
}

.bodyText {
    white-space: pre-wrap;
}

.collapseChevron {
    transition: transform 200ms ease;
}

.collapseChevronClosed {
    transform: rotate(-90deg);
}
